import script from "./ValidatorsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatorsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ValidatorsComponent.vue?vue&type=style&index=0&id=636002bf&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-636002bf"]])

export default __exports__